import React from "react";

const SectionHeading = ({ eyebrow, title, center = false, light = false }) => {
  return (
    <div className={`mb-10 ${center ? "text-center" : ""}`}>
      {eyebrow && (
        <p className="font-heading italic font-bold text-p3-gold uppercase tracking-wide text-sm mb-2">{eyebrow}</p>
      )}
      <h2 className={`font-heading font-extrabold text-3xl md:text-4xl ${light ? "text-white" : "text-p3-navy"}`}>
        {title}
      </h2>
      <div className={`h-1 w-16 bg-p3-gold rounded-full mt-4 ${center ? "mx-auto" : ""}`} />
    </div>
  );
};

export default SectionHeading;
